<!-- The following is a popup dialog to select a pass template -->

<p-dialog appendTo="body" header="Pass Template Selection" [(visible)]="displayPassTemplateDialog" 
    [focusOnShow]="false" [responsive]="true"     styleClass="wal-dialog"
        showEffect="fade" [modal]="true"  [style]="{width: '40%'}" position="topleft" [showHeader]="true">

    <div class="ui-g">
        <div class="col-12">

            <p-table #dt [columns]="passTemplateCols" [value]="passTemplates" selectionMode="single" 
                [(selection)]="selectedPassTemplate"  class="wal-table"
                sortMode="multiple" (onRowSelect)="onRowPassTemplateSelect($event)" [paginator]="true" [rows]="15" >
              <ng-template pTemplate="header" let-columns>
                  <tr>
						@for (col of columns; track col.field) {
							<th [pSortableColumn]="col.field"
								[style.display]="col.display"
								[style.width]="col.width">
								{{ col.header }}
								<p-sortIcon [field]="col.field"></p-sortIcon>
							</th>
						}
                </tr>
                <tr>

                    @for (col of columns; track col.field) {
                        <th [style.width]="col.width" [style.display]="col.display">
                            @switch (col.field) {
                                @case ('passName') {
                                    <input pInputText type="text" [style.width]="'100%'"
                                        (input)="dt.filter(($any($event.target)).value, col.field, 'contains')"
                                    />
                                }
                                @default {
                                }
                            }
                        </th>
                    }

                </tr>  
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="columns">
                  <tr [pSelectableRow]="rowData">
                        @for (col of columns; track col.field) {
                            <td [style.width]="col.width" [style.display]="col.display">
                                {{ rowData[col.field] }}
                            </td>
                        }
                  </tr>
              </ng-template>
            </p-table> 
      
        </div>
    </div>


    <ng-template #footer>
        <div class="footer-actions">
            <button type="button" pButton icon="fa fa-check" (click)="onPassTemplateSelect()" label="Select"></button>
            <button type="button" pButton icon="fa fa-check" (click)="onCancelPassTemplateSelect()" label="Cancel"></button>
        </div>
    </ng-template>


</p-dialog>


